<template>
  <Transition name="modal">
    <div class="joint-modal-mask">
      <div class="joint-modal-container joint-modal-body">
        <div class="joint-modal-close" @click="closeModal">
          <i class="fa-solid fa-xmark"></i>
        </div>

        <div class="joint-modal-content text-center">
          <div class="joint-icon-bg">
            <img
              :src="
                useAsset(
                  'img/merchant-console/super-monarch/credit_card_check.svg'
                )
              "
              alt="icon"
            />
          </div>

          <h3 class="joint-title">{{ title }}</h3>
          <p class="joint-subtitle" v-html="subtitle"></p>

          <ul class="joint-features list-unstyled mt-4 text-start">
            <li class="d-flex align-items-start mb-3">
              <img
                class="feature-icon"
                :src="useAsset('img/merchant-console/super-monarch/alert.svg')"
                alt="icon"
              />
              <span class="feature-text">{{ feature1 }}</span>
            </li>
            <li class="d-flex align-items-start">
              <img
                class="feature-icon"
                :src="
                  useAsset('img/merchant-console/super-monarch/trending_up.svg')
                "
                alt="icon"
              />
              <span class="feature-text">{{ feature2 }}</span>
            </li>
          </ul>

          <div class="joint-actions mt-4">
            <button
              class="btn btn-primary w-100 joint-cta"
              @click="closeModal()"
            >
              {{ primaryLabel }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { defineEmits } from "vue";
import useAsset from "@/apps/merchant3/shared-helpers/useAsset";
import { useI18n } from "@/apps/merchant3/composables/useI18n";

const emit = defineEmits(["closeModal"]);
const { t } = useI18n();

// Use i18n keys if present; fallback strings provided
const title = t("JOINT_LOAN_EXISTING_LINE_MODAL.TITLE");
const subtitle = t("JOINT_LOAN_EXISTING_LINE_MODAL.SUBTITLE");
const feature1 = t("JOINT_LOAN_EXISTING_LINE_MODAL.FEATURE_1");
const feature2 = t("JOINT_LOAN_EXISTING_LINE_MODAL.FEATURE_2");
const primaryLabel = t("JOINT_LOAN_EXISTING_LINE_MODAL.BUTTON");

const closeModal = () => {
  emit("closeModal", true);
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.joint-modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
}

.joint-modal-container {
  min-width: 320px;
  width: 375px;
  max-width: calc(100% - 40px);
  margin: 0 auto;
}

.joint-modal-body {
  background: $pj-color-white;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  padding: 30px;
  position: relative; // make the close button position relative to this element
}

.joint-modal-close {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -50px; // float further above the modal
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #fff; // make the X white
  z-index: 9999; // ensure it sits above the modal for the floating effect

  i {
    font-size: 36px;
    margin: 0;
  }
}

.joint-modal-content {
  padding-top: 6px;
}

.joint-icon-bg {
  width: 64px;
  height: 64px;
  margin: 0 auto 12px;
  border-radius: 50%;
  background: rgba(11, 107, 43, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
}

.joint-title {
  margin: 6px 0 0;
  font-size: 18px;
  color: $pj-color-black;
  font-weight: 600;
}

.joint-subtitle {
  margin: 6px 0 18px;
  font-size: 18px;
  color: $pj-color-green;
  font-weight: 700;
}

.joint-features .feature-icon {
  width: 22px;
  margin-right: 12px;
}

.feature-text {
  color: $pj-color-black;
}

.joint-actions .joint-cta {
  background: $pj-color-green;
  border-color: $pj-color-green;
  color: #fff;
  padding: 10px 14px;
  border-radius: 6px;
  font-weight: 700;
}

/* mobile bottom sheet */
@media screen and (max-width: 420px) {
  .joint-modal-mask {
    align-items: flex-end;
  }
  .joint-modal-container {
    width: 100%;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
    margin: 0;
  }
  .joint-modal-body {
    padding-bottom: 20px;
  }
  .joint-modal-close {
    top: -28px;
  }
}

/* transition helpers */
.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .joint-modal-container,
.modal-leave-to .joint-modal-container {
  transform: translateY(-20px);
  opacity: 0;
}
</style>
